import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../common/html/element'
import { BackToPreviousPage } from './BacktoPreviousPage'
import classes from './ErrorCommon.module.scss'
import { GoToDashboard } from './GoToDashboard'
import { Logout } from './Logout'

export const ErrorCommon = ({
  statusCode,
  title,
  renderAppendContent,
  setIsShowViewPlan,
  setShowTrial,
  isLogout,
}) => {
  return (
    <div className={classes.container}>
      <div className="flexColumn textCenter alignItemsCenter">
        <Element
          elementName="span"
          className="fw500"
          style={{
            color: '#0553A5',
            fontSize: 48,
            fontStyle: 'italic',
          }}
        >
          Oops!
        </Element>
        <Element
          elementName="span"
          className="fww600"
          style={{ color: '#8BA0BF', fontSize: 180 }}
        >
          {statusCode}
        </Element>
        <Element
          elementName="span"
          className="fw500"
          style={{ color: '#0553A5', fontSize: 48, whiteSpace: 'pre-line' }}
        >
          <Translate value={title} />
        </Element>
        {setIsShowViewPlan && setShowTrial
          ? renderAppendContent(setIsShowViewPlan, setShowTrial)
          : renderAppendContent()}
        <div className="dFlex gap2 mt3">
          {isLogout ? (
            <Logout />
          ) : (
            <>
              <GoToDashboard />
              <BackToPreviousPage />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

ErrorCommon.propTypes = {
  statusCode: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  renderAppendContent: PropTypes.func,
  hiddenButton: PropTypes.bool,
}

ErrorCommon.defaultProps = {
  renderAppendContent: () => {},
  hiddenButton: false,
}
